import * as THREE from 'three'
import { useShipActionStore } from '@/stores/shipActionStore.ts'
import { useShipStore } from '@/stores/shipStore.ts'
import { useMapStore } from '@/stores/mapStore.ts'
import { MapETA } from '@/models/Map/MapETA.ts'
import { logger } from '@/models/logger';

export class ShipActionPath {

    scene: THREE.Scene;
    pendingActionLine: THREE.Line | null;
    pendingActionETA: MapETA | null;
    actionLines: THREE.Line[] = [];
    actionETAs: MapETA[] = [];
    shipActionStore: any;
    shipStore: any;
    mapStore: any;

    constructor(scene: THREE.Scene) {
        this.scene = scene;
        this.pendingActionLine = null;
        this.pendingActionETA = null;
        this.shipActionStore = useShipActionStore();
        this.shipStore = useShipStore();
        this.mapStore = useMapStore()
    }

    setPendingAction(x: number, y: number) {
        logger.debug('setPendingAction', x, y, this.shipActionStore.pendingAction);
        if (this.pendingActionLine !== null || (this.shipActionStore.pathEndX === 0 && this.shipActionStore.pathEndY === 0)) {
            return;
        }

        // Create the line
        const material = new THREE.LineBasicMaterial({ color: 0x0000ff });
        const points = [];
        const startX = this.shipActionStore.pathEndX;
        const startY = this.shipActionStore.pathEndY;
        points.push(new THREE.Vector3(startX, startY, 0.2));
        points.push(new THREE.Vector3(x, y, 0.2));
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        this.pendingActionLine = new THREE.Line(geometry, material);
        this.pendingActionLine.name = 'actionLine';
        this.scene.add(this.pendingActionLine);

        this.pendingActionETA = new MapETA(this.pendingActionLine);
    }


    removePendingAction() {
        logger.debug('removePendingAction');
        if (this.pendingActionETA) {
            this.pendingActionETA.dispose();
            this.pendingActionETA = null;
        }
        if (this.pendingActionLine) {
            this.scene.remove(this.pendingActionLine);
            this.pendingActionLine = null;
        }
    }
    queuePendingAction(x: number, y: number, targetPlayer: number, targetShip: number, duration?: number) {
        // add the action to the queue
        this.shipActionStore.queuePendingAction(x, y, targetPlayer, targetShip, duration);
        this.removePendingAction();
        this.setActionPath();
    }
    removeLastAction() {
        if (this.shipActionStore.actions.length > 0) {
            this.shipActionStore.actions.pop();
            this.recalculatePathEnd()
            this.setActionPath();
        }
    }
    recalculatePathEnd(){
        this.shipActionStore.pathEndX = this.shipActionStore.pathStartX;
        this.shipActionStore.pathEndY = this.shipActionStore.pathStartY;
        this.shipActionStore.actions.forEach((action: any) => {
            // Skip stationary actions that don't change position
            if (action.action === 'repair' || action.action === 'defend' || action.action === 'wait') {
                return;
            }
            this.shipActionStore.pathEndX = action.targetX;
            this.shipActionStore.pathEndY = action.targetY;
        });
    }
    resetActionPath() {
        this.shipActionStore.actions = [];
        this.shipActionStore.pathEndX = this.shipActionStore.pathStartX;
        this.shipActionStore.pathEndY = this.shipActionStore.pathStartY;
        this.setActionPath();
    }

    updateZoom(newZoom: number) {
        if (this.pendingActionETA) {
            this.pendingActionETA.updateZoom(newZoom);
        }
        for (const eta of this.actionETAs) {
            eta.updateZoom(newZoom);
        }
    }

    setActionPath(): void {
        logger.debug('setActionPath')
        // remove all action lines and ETAs
        this.actionETAs.forEach((eta) => {
            eta.dispose();
        });
        this.actionETAs = [];
        this.actionLines.forEach((line) => {
            this.scene.remove(line);
        });
        this.actionLines = [];

        let startX = this.shipActionStore.pathStartX;
        let startY = this.shipActionStore.pathStartY;
        // add all action lines
        this.shipActionStore.actions.forEach((action: any) => {
            // Skip stationary actions that don't draw lines
            if (action.action === 'repair' || action.action === 'defend' || action.action === 'wait') {
                return;
            }
            // when there is no first point to draw a line from, we just skip it, otherwise it will draw it from the left-bottom corner.
            if(startX !== 0 && startY !== 0 && action.targetX !== 0 && action.targetY !== 0) {
                const material = new THREE.LineBasicMaterial({ color: 0x0000ff });
                const points = [];
                points.push(new THREE.Vector3(startX, startY, 0.2));
                points.push(new THREE.Vector3(action.targetX, action.targetY, 0.2));
                const geometry = new THREE.BufferGeometry().setFromPoints(points);
                const line = new THREE.Line(geometry, material);
                line.name = 'actionLine';
                this.actionLines.push(line);
                this.scene.add(line);

                const eta = new MapETA(line);
                this.actionETAs.push(eta);
            }
            startX = action.targetX;
            startY = action.targetY

        });

    }
}